module.exports = __webpack_public_path__ + "./phin_9570abb3bd7c55f92e2cd24562f41314.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2017/phin.png
// module id = 454
// module chunks = 0